import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class JwtService {
    private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

    /** Returns a safe Storage reference only in the browser */
    private get storage(): Storage | null {
        // Using globalThis avoids TS errors in some setups and is SSR-safe when guarded
        return this.isBrowser ? globalThis.localStorage : null;
    }

    getToken(): string | null {
        return this.storage?.getItem('accessToken') ?? null;
    }

    getExpiresAt(): number | null {
        const raw = this.storage?.getItem('access_token_expires_at');
        return raw ? Number(raw) : null;
    }

    setSession(token: string, expiresAt: number): void {
        this.storage?.setItem('accessToken', token);
        this.storage?.setItem('access_token_expires_at', String(expiresAt));
    }


    isValid(): boolean {
        const token = this.getToken();
        const exp = this.getExpiresAt();
        if (!token || !exp) return false;
        return Date.now() + 30000 < exp;
    }

    removeSession(): void {
        this.storage?.removeItem('accessToken');
        this.storage?.removeItem('access_token_expires_at');
    }
}
